const BASIC_DETAILS_TAB = [
  "Name",
  "Mobile Number",
  "Email",
  "DOB",
  "Pan Number",
];

const BUSINESS_DETAILS_TAB = [
  "Business Name",
  "Business Type",
  "Business Address",
  "GST Number",
  "Website Link",
  "Legal Name",
  "Industry Type",
  "DIN Check",
  "DPAN Check",
];

const REMITTER_ACCOUNT_BANK_DETAILS_TAB = [
  "Remitter Name As per Bank ",
  "Remitter Account Number",
  "Remitter IFSC",
  "Debitor Account Number",
  "Debitor IFSC",
  "Corp Id",
  "User Id",
];

const SETTLEEMENT_BANK_DETAILS_TAB = [
  "Settlement Name As Per Bank ",
  "Settlement Account Number",
  "Settlement IFSC",
];

const PRIVATE_PUBLIC_DOCUMENTS_TAB = [
  "Signed SLA",
  "PAN card",
  "GST Certificate",
  "Incorporation certificate",
  "NDA Certificate",
  "Cancelled Cheque",
  "KYC of the Signing authority",
  "Memorandum of Association",
  "Article of Association",
  "Merchant Approval Form",
  "Onboarding Docs(UPI)",
];

const PARTNERSHIP_DOCUMENTS_TAB = [
  "Partnership Deed",
  "PAN CARD",
  "Aadhaar",
  "Shop and Establishment certificate",
  "Udyod Aadhaar/Udhyam Certificate",
  "Signed SLA",
  "NDA",
  "Cancelled Cheque",
  "Agreement",
  "Merchant Onboarding",
  "Onboarding Docs(UPI)",
  "Others",
];

const SOLE_PROPRIETORSHIP_DOCUMENTS_TAB = [
  "PAN CARD",
  "Aadhaar",
  "Shop and Establishment certificate",
  "Udyod Aadhaar/Udhyam Certificate",
  "Signed SLA",
  "NDA",
  "Cancelled Cheque",
  "Agreement",
  "Merchant Onboarding",
  "Onboarding Docs(UPI)",
  "Others",
];

const SERVICE_TYPE_DETAILS_TAB = [
  "Service Type",
  "Service Provider Name",
  "Service Provider Rate",
  "Neokred Rate",
  "Reseller Rate",
  "Client Rate",
  "Ip whitelisting",
];

const KYC_DETAILS_TAB = ["Kyc Video", "Rolling Reserve", "Security Deposit"];

const TRANSACTION_LIMIT_DETAILS_TAB = ["Transaction Limit"];

const DOCUMENTS_DETAILS_TAB = {
  Partnership: PARTNERSHIP_DOCUMENTS_TAB,
  SoleProprietorship: SOLE_PROPRIETORSHIP_DOCUMENTS_TAB,
  Public: PRIVATE_PUBLIC_DOCUMENTS_TAB,
  PrivateLimited: PRIVATE_PUBLIC_DOCUMENTS_TAB,
};

const BANK_DETAILS_TAB = {
  payin: SETTLEEMENT_BANK_DETAILS_TAB,
  payout: REMITTER_ACCOUNT_BANK_DETAILS_TAB,
};

export const setCommentsHeader = (currentTab, data) => {
  let bankDetailsTab = [];
  const payin = data?.service?.find(
    (o) =>
      o?.serviceType?.toUpperCase() === "PAYIN" ||
      o?.serviceType?.toUpperCase() === "VAN"
  );
  const payout = data?.service?.find(
    (o) => o?.serviceType?.toUpperCase() === "PAYOUT"
  );
  if (payin) {
    bankDetailsTab = [...bankDetailsTab, ...BANK_DETAILS_TAB.payin];
  }
  if (payout) {
    bankDetailsTab = [...bankDetailsTab, ...BANK_DETAILS_TAB.payout];
  }

  switch (currentTab) {
    case 0:
      return BASIC_DETAILS_TAB;
    case 1:
      return BUSINESS_DETAILS_TAB;
    case 2:
      return bankDetailsTab;
    case 3:
      return DOCUMENTS_DETAILS_TAB[data?.businessType];
    case 4:
      return KYC_DETAILS_TAB;
    case 5:
      return SERVICE_TYPE_DETAILS_TAB;
    case 6:
      return TRANSACTION_LIMIT_DETAILS_TAB;
    default:
      return null;
  }
};
